import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API,
    timeout: 240000,
    headers: {
        'Authorization': localStorage.getItem('access_token') ? "JWT " + localStorage.getItem('access_token') : null,
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
});

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;
        console.log("🧪 error", error)
        if (error.message && error.message.indexOf("timeout") > -1) {
            return window.alert("timeout. please contact admin for this error")
        }

        if (error.response && error.response.data.code === "token_not_valid") {
            const refreshToken = localStorage.getItem('refresh_token');

            if (refreshToken){
                const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));

                // exp date in token is expressed in seconds, while now() returns milliseconds:
                const now = Math.ceil(Date.now() / 1000);
                console.log(tokenParts.exp);

                if (tokenParts.exp > now) {
                    return axiosInstance.post(`https://api.cl-ds.com/token/refresh/`, {refresh: refreshToken})
                    .then((response) => {
                        localStorage.setItem('access_token', response.data.access);
                        //    localStorage.setItem('refresh_token', response.data.refresh);
        
                        axiosInstance.defaults.headers['Authorization'] = "JWT " + response.data.access;
                        originalRequest.headers['Authorization'] = "JWT " + response.data.access;
        
                        return axiosInstance(originalRequest);
                    })
                    .catch(err => {
                        console.log(err)
                    });
                }else{
                    console.log("Refresh token is expired", tokenParts.exp, now);
                    localStorage.clear()
                    window.location.href = '/login/';
                    return Promise.reject(error);
                }
            }else{
                console.log("Refresh token not available.")
                localStorage.clear()
                window.location.href = '/login/';
                return Promise.reject(error);
            }
        }
        
        // specific error handling done elsewhere
        return Promise.reject(error);
    }
);

export default axiosInstance;